/**
 * localStorage helpers. Keys are the original ones so an AM's current sheet and search carry over:
 * ic2_sheet (current cost sheet), ic2_bomq (search), ic_lang, ic2_ask, ic_set (legacy settings, key removed).
 * New: ic2_sheet_id (server id of the current sheet), ic2_bomscroll.
 */
export const KEYS = {
  sheet: "ic2_sheet", bomq: "ic2_bomq", lang: "ic_lang", ask: "ic2_ask", settings: "ic_set",
  sheetId: "ic2_sheet_id", bomScroll: "ic2_bomscroll", qcoef: "ic_qcoef", savedFp: "ic2_saved_fp", qcoefQty: "ic_qcoef_qty", cur: "ic_cur",
} as const;

export function lsGet<T>(k: string, d: T): T {
  try { const v = localStorage.getItem(k); return v == null ? d : (JSON.parse(v) as T); } catch { return d; }
}

export function lsSet(k: string, v: unknown): void {
  try { localStorage.setItem(k, JSON.stringify(v)); } catch { /* quota / private mode */ }
}

export function lsDel(k: string): void {
  try { localStorage.removeItem(k); } catch { /* ignore */ }
}

/**
 * The original tool, and the temporary browser-direct test mode (removed 2026-09-30), stored the API key in the
 * browser. It now lives on the server only: delete any leftover. Returns true if a key was found.
 */
export function dropLegacyKey(): boolean {
  const s = lsGet<Record<string, unknown> | null>(KEYS.settings, null);
  if (!s) return false;
  lsDel(KEYS.settings);
  return !!s.key;
}
